module.exports = __webpack_public_path__ + "img/biblioteca.f0161f8c.png";